// CSS Imports
import './css/global.css'
import './css/webfonts.css';
import './css/icons.css'
import './css/header.css'
import './css/homeHero.css';
import './css/hero.css';
import './css/form.css';
import './css/faqs.css';
import './css/imageGallery.css';
import './css/newsletter.css';
import './css/footer.css';
import './css/propertyTeaser.css';
import './css/textImage.css';
import './css/projectHighlights.css'
import './css/quickFacts.css'
import './css/projectCarousel.css'
import './css/rentObjectOverview.css'
import './css/propertyOverview.css'
import './css/circleTeaser.css'
import './css/search.css'
import './css/anim.css'


import GoogleMap from '@components/google-map/googleMap'
import OiForm from '@components/oi-form/OiForm'
import OiFaq from '@components/oi-faq/OiFaq'
import OiHeader from "@components/oi-header/OiHeader";
import EventBus from '@helpers/EventBus'
import OiImageGallery from '@components/oi-imageGallery/OiImageGallery'
import OiProjectCarousel from './components/oi-projectCarousel/OiProjectCarousel';
import OiBlogOverview from "@components/oi-blogOverview/OiBlogOverview";
import OiProjectHighlights from "@components/oi-projectHighlights/OiProjectHighlights";
import OiOpeningHours from '@components/oi-openingHours/OiOpeningHours'
import OiRentObjectOverview from '@components/oi-rentObjectOverview/OiRentObjectOverview';
import OiNewsletter from "@components/oi-newsletter/OiNewsletter";
import OiSearch from "@components/oi-search/OiSearch";
import OiAnim from '@helpers/OiAnim'


customElements.define('google-map', GoogleMap)


 // Add the class js-open-cookie-banner on any element. A click on it opens the cookie banner
document.querySelectorAll('.js-open-cookie-banner').forEach((element) => {
    element.addEventListener('click', () => {
        EventBus.$emit('openCookieBanner')
    })
})


// Create an instance of OiForm for each element
const oiFormElements = document.querySelectorAll('.js-oi-form');
oiFormElements.forEach((element) => {
    new OiForm(element as HTMLElement);
});

// Create an instance of OiForm for each element
const oiNewsletterElements = document.querySelectorAll('.js-oi-newsletter');
oiNewsletterElements.forEach((element) => {
    new OiNewsletter(element as HTMLElement);
});

// initialize OiFaq components
const oiFaqElements = document.querySelectorAll('.js-oi-faq');
oiFaqElements.forEach((element) => {
    new OiFaq(element as HTMLElement);
});

// initialize OiHeader components
const oiHeaderElements = document.querySelectorAll('.js-oi-header');
oiHeaderElements.forEach((element) => {
    new OiHeader(element as HTMLElement);
});

// initialize ImageGallery component
const imageGalleries = document.querySelectorAll('.js-oi-image-gallery')
imageGalleries.forEach(element => {
    new OiImageGallery(element as HTMLElement)
})

// initialize OiProjectCarousel components
const projectCarousels = document.querySelectorAll('.js-oi-project-carousel');
projectCarousels.forEach(element => {
    new OiProjectCarousel(element as HTMLElement);
});

// initialize OiBlogOverview components
const blogOverviews = document.querySelectorAll('.js-oi-blog-overview');
blogOverviews.forEach(element => {
    new OiBlogOverview(element as HTMLElement);
});

// initialize OiProjectHighlights components
const projectHighlightsElements = document.querySelectorAll('.js-oi-project-highlights');
projectHighlightsElements.forEach(element => {
    new OiProjectHighlights(element as HTMLElement);
});

const hoursContainers = document.querySelectorAll<HTMLElement>('.js-oi-hours-container')
hoursContainers.forEach(container => {
    new OiOpeningHours(container)
})

const rentObjectOverviews = document.querySelectorAll<HTMLElement>('.js-oi-rentObject-overview');
rentObjectOverviews.forEach(overview => {
    if (overview) {
        new OiRentObjectOverview(overview);
    }
});

const searchForms = document.querySelectorAll<HTMLElement>('.js-oi-search');
searchForms.forEach(search => {
    if (search) {
        new OiSearch(search);
    }
});

const oiAnims = document.querySelectorAll('.js-oi-anim');
oiAnims.forEach((element) => {
    new OiAnim(element as HTMLElement);
});